import { Customer, CustomerConfig } from '../../models/customer.config';
import { Observable } from 'rxjs';

export abstract class CustomerService {
  abstract getCustomer(): Promise<Customer | undefined>

  abstract getCustomerConfig(): CustomerConfig | undefined;

  abstract getCustomerConfig$(): Observable<CustomerConfig>;

  abstract getCustomerName$(): Observable<string>;

  abstract loadCustomer(): void;

  abstract getCustomerHomepageUrl(): Observable<string>
}
